// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-footer {
    background-color: var(--home-primary-color);
    color: #ffffff;
    direction: rtl;
    padding: 1rem 1rem 0 1rem;
    width: 100%;
    position: relative;
    bottom: 0;
}

.footer-container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 0.5rem;
}

.footer-grid {
    display: flex;    
    justify-content:space-around;
}

@media (min-width: 768px) {
    .footer-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

.footer-section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.footer-section {
    font-weight: 500;
}

.footer-heading {
    font-size: 1.125rem;
    font-weight: bold;
    margin: 0;
}

.footer-text {
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.8);
}

.footer-text > div {
    display: flex;
    gap: 1rem;
}

.social-links {
    display: flex;
    gap: 1rem;
}

.social-link {
    color: #ffffff;
    transition: color 0.3s ease;
}

.social-link:hover {
    color: rgba(255, 255, 255, 0.8);
}

.social-icon {
    width: 1.25rem;
    height: 1.25rem;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.footer-link {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 0.875rem;
    transition: color 0.3s ease;
}

.footer-link:hover {
    color: #ffffff;
    text-decoration: underline;
}

.footer-address {
    font-style: normal;
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.8);
}

.footer-copyright {
    margin: 0 1rem 0.5rem 1rem;
    padding-top: 0.5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    text-align: center;
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.8);
}

.footer-copyright p {
    margin: 0;
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}

@media (max-width: 800px) {
    .footer-container {
        padding: 0 0.5rem;
    }

    .footer-grid {
        gap: 1.5rem;
    }

    .footer-section {
        gap: 0.75rem;
        padding: 0.5rem 0;
    }

    .footer-heading {
        font-size: 1rem;
        margin-bottom: 0.25rem;
    }

    .footer-links {
        gap: 0.4rem;
    }

    .footer-link,
    .footer-address,
    .footer-text {
        font-size: 0.8rem;
        line-height: 1.5;
    }

    .footer-address,
    .footer-text {
        margin-top: 0.25rem;
    }

    .social-links {
        gap: 0.75rem;
        margin-top: 0.5rem;
    }

    .footer-copyright {
        margin: 0 0.5rem 0.5rem 0.5rem;
        padding-top: 0.5rem;
        font-size: 0.75rem;
    }
}

@media (max-width: 480px) {
    .footer-heading {
        font-size: 0.95rem;
    }

    .footer-link,
    .footer-address,
    .footer-text {
        font-size: 0.75rem;
    }

    .footer-copyright {
        font-size: 0.7rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;IAC3C,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,8CAA8C;IAC9C,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;;;QAGI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;QAC9B,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;;;QAGI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".site-footer {\n    background-color: var(--home-primary-color);\n    color: #ffffff;\n    direction: rtl;\n    padding: 1rem 1rem 0 1rem;\n    width: 100%;\n    position: relative;\n    bottom: 0;\n}\n\n.footer-container {\n    max-width: 1000px;\n    margin: 0 auto;\n    padding: 0 0.5rem;\n}\n\n.footer-grid {\n    display: flex;    \n    justify-content:space-around;\n}\n\n@media (min-width: 768px) {\n    .footer-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n.footer-section {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.footer-section {\n    font-weight: 500;\n}\n\n.footer-heading {\n    font-size: 1.125rem;\n    font-weight: bold;\n    margin: 0;\n}\n\n.footer-text {\n    font-size: 0.875rem;\n    color: rgba(255, 255, 255, 0.8);\n}\n\n.footer-text > div {\n    display: flex;\n    gap: 1rem;\n}\n\n.social-links {\n    display: flex;\n    gap: 1rem;\n}\n\n.social-link {\n    color: #ffffff;\n    transition: color 0.3s ease;\n}\n\n.social-link:hover {\n    color: rgba(255, 255, 255, 0.8);\n}\n\n.social-icon {\n    width: 1.25rem;\n    height: 1.25rem;\n}\n\n.footer-links {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.footer-link {\n    color: rgba(255, 255, 255, 0.8);\n    text-decoration: none;\n    font-size: 0.875rem;\n    transition: color 0.3s ease;\n}\n\n.footer-link:hover {\n    color: #ffffff;\n    text-decoration: underline;\n}\n\n.footer-address {\n    font-style: normal;\n    font-size: 0.875rem;\n    color: rgba(255, 255, 255, 0.8);\n}\n\n.footer-copyright {\n    margin: 0 1rem 0.5rem 1rem;\n    padding-top: 0.5rem;\n    border-top: 1px solid rgba(255, 255, 255, 0.2);\n    text-align: center;\n    font-size: 0.875rem;\n    color: rgba(255, 255, 255, 0.8);\n}\n\n.footer-copyright p {\n    margin: 0;\n}\n\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0;\n}\n\n@media (max-width: 800px) {\n    .footer-container {\n        padding: 0 0.5rem;\n    }\n\n    .footer-grid {\n        gap: 1.5rem;\n    }\n\n    .footer-section {\n        gap: 0.75rem;\n        padding: 0.5rem 0;\n    }\n\n    .footer-heading {\n        font-size: 1rem;\n        margin-bottom: 0.25rem;\n    }\n\n    .footer-links {\n        gap: 0.4rem;\n    }\n\n    .footer-link,\n    .footer-address,\n    .footer-text {\n        font-size: 0.8rem;\n        line-height: 1.5;\n    }\n\n    .footer-address,\n    .footer-text {\n        margin-top: 0.25rem;\n    }\n\n    .social-links {\n        gap: 0.75rem;\n        margin-top: 0.5rem;\n    }\n\n    .footer-copyright {\n        margin: 0 0.5rem 0.5rem 0.5rem;\n        padding-top: 0.5rem;\n        font-size: 0.75rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .footer-heading {\n        font-size: 0.95rem;\n    }\n\n    .footer-link,\n    .footer-address,\n    .footer-text {\n        font-size: 0.75rem;\n    }\n\n    .footer-copyright {\n        font-size: 0.7rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
